import React from 'react';
import classes from './IsoPage.module.css';
import { BasicContainer, ContainerFull } from '../../UI/ContentContainer';
import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Box, Container, Typography } from '@mui/material';

import iso45001 from '../../../assets/img/iso_page/45001.png';
import process from '../../../assets/img/iso_page/45001_process.png';
import chart from '../../../assets/img/iso_page/chart.png';
import person from '../../../assets/img/iso_page/5person.png';


import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { DefaultList} from '../../UI/List/List';
import MetaTags from '../../MetaTags/MetaTags';



const effect = [
    "각종 법규 및 규제에 대한 대응",
    "산업재해에 대한 각종 소송에 대응",
    "기업의 글로벌화",
    "비즈니스 프로세스의 연장으로서의 안전",
    "지속적인 개선을 위한 측정 및 모니터링",
    "기업인의 의무 및 이해자 집단(NGO)에 대한 책임",
    "사고로부터 인명과 재산을 보호",
    "작업장 내의 위험성을 관리, 예방하여 재해사고율 감소",
    "신뢰성 있는 안전보건경영시스템 구축으로 산재보험율 감소",
    "은행 및 보험사로부터의 신뢰성 구축",
    "투자에 대한 안정감 제공",
    "근로자의 보건안전 위험성의 개선을 통한 생산성 향상",
    "ISO 9001, ISO 14001 과 함께 통합시스템 구축 용이",
    "안전부분의 무역장벽을 제거하여 해외시장 진출 용이",
    "상호인정협정이 가능한 공인된 안전보건경영시스템 구축으로 수출비용 절감",
    "기업의 자율 안전보건관리 체제가 조속히 정착",
    "안전보건에 대한 근로자의 편향된 불만을 해소하여 노사관계 안정에 기여",
    "공공기관 또는 민간 입찰 참여 시 적격성 근거자료로 활용",
    "ESG 경영 실천을 인정받는 지표 중 하나",
]

const IsoPage = () => {
    return (
        <BasicContainer>
            <MetaTags
                title="ISO 45001 인증"
                description="ISO 45001 인증 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-ISO 45001 인증"
                ogdescription="ISO 45001 인증 대해 소개 합니다."
            />
            <PageTitle title="ISO 45001 인증" />
            <TextContent>
                <Grid container justifyContent='center' alignItems='center'>
                    <Grid sm={12} md={3} textAlign='center'>
                        <img src={iso45001} alt="45001.png" style={{width:'10rem'}}/>
                    </Grid>
                    <Grid sm={12} md={9}>
                        <Typography variant="pageTitle" component="h2" textAlign="left">개요</Typography>
                        <Typography variant="description" component="p">
                            ISO 45001(안전보건경영시스템)은 조직이 산업재해예방과 쾌적한 작업환경 조성을 목적으로 조직의 업무와 관련된 노동자의 상해 및 질병을 예방하고 안전보건성과를 개선함으로써 안전하고 건강한 작업 공간을 제공할 수 있도록 구성되었습니다.
                            사업장에서 발생할 수 있는 각종 위험을 사전예측 예방하여 궁극적으로 기업의 이윤창출에 기여하고 조직의 안전보건을 체계적으로 관리하기 위한 요구사항을 규정한 국제표준입니다.
                        </Typography>
                    </Grid>
                </Grid>
            </TextContent>

            <ContainerFull>
                <Container maxWidth="lg" data-aos="fade-up">
                    <Typography variant="pageTitle" component="h2" textAlign="center">도입 필요성 및 효과</Typography>
                    <Typography variant="description" component="p">
                        중대재해처벌법의 양벌규정에 따라 조직에서 중대재해 위법행위가 적발되더라도 조직이 안전 및 보건 의무 위반행위를 방지하기 위해 해당 업무에 관하여 상당한 주의와 감독을 기울였을 경우에는 처벌이 면책될 뿐만 아니라, 형벌의 양형과 배상액 산정 시 반영될 수 있어 법 위반과 관련된 비용과 벌칙 최소화
                    </Typography>

                    <Grid container alignItems="center" sx={{backgroundColor: 'white', borderRadius:"1rem", marginTop: '2rem'}}>
                        <Grid xs={12} md={6}>
                            <img src={chart} alt="chart.png" className={classes.chartImage}/>
                        </Grid>
                        <Grid xs={12} md={6}>
                            <Box marginTop="1rem">
                                <Typography variant="contentTitleSmall" component="h5">안전보건경영시스템 인증효과</Typography>
                                <DefaultList data={effect} style={{listStyle:'circle'}}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </ContainerFull>

            <TextContent title="중대재해처벌법 적용대상" data-aos="fade-up">
                <Grid container justifyContent='center' alignItems='center'>
                    <Grid xs={12} md={3} textAlign='center'>
                        <img src={person} alt="5person.png"/>
                    </Grid>
                    <Grid xs={12} md={9} className={classes.box}>
                        <Typography variant="contentTitleSmall" component="p">- 상시 근로자 5인 이상 사업 또는 사업장</Typography>
                        <Typography variant="contentTitleSmall" component="p">- 건설, 화학, 제조, 식품, 의약, IT, 호텔, 유통, 서비스, 학교, 정부, 지자체, 공공기관 등 모든 5인 이상 조직</Typography>
                    </Grid>
                </Grid>
            </TextContent>

            <TextContent title="인증 절차" data-aos="fade-up">
                <Box textAlign='center'>
                    <img src={process} alt="45001_process.png" style={{width:'100%', maxWidth: '645px'}}/>
                </Box>
            </TextContent>

                
        </BasicContainer>
    )
}

export default IsoPage;